import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DisplayValueDateWithTime({
  value
}) {
  if (!value || !I18n.moment.isMoment(value)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.customerDataFilters.DisplayValueDate.invalid"
    });
  }

  // FormattedDateTime component displays date in a portalTz so if a moment date
  // passed to it has a different TZ it will be converted. Since we need to display
  // a date in the filter's timezone we don't want this conversion to happen.
  // To prevent the conversion the value is manually switched to a portalTz
  // but without applying time offset between the timezones
  const valueWithPortalTz = value.clone().tz(I18n.moment.portalTz().tz() || 'UTC', true);
  const tzFormat = value.tz() || value.isUTC() ? 'z' : 'Z';
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(FormattedDateTime, {
      format: "L",
      type: "portalTz",
      value: valueWithPortalTz
    }), ', ', /*#__PURE__*/_jsx(FormattedDateTime, {
      format: "LT",
      type: "portalTz",
      value: valueWithPortalTz
    }), ` (${value.format(tzFormat)})`]
  });
}